/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { PublicClouds } from './components';

export interface ProtectedDataPublicCloudsPageProps {
    currentPath?: string;
}

export const ProtectedDataPublicCloudsPage: React.FC<ProtectedDataPublicCloudsPageProps> = ({ currentPath }) => (
    <TabBarBodyLayout>
        <PublicClouds stateId={currentPath} />
    </TabBarBodyLayout>
);
